export default {
    get(dom) {
        if (typeof dom ==='string') {
            dom = document.querySelector(dom);
        }

        if (dom) {
            return new class {
                content = dom.querySelector('.alert-content');
                element = dom;
                icon    = dom.querySelector('i');

                set_color(color) {
                    let icons = {
                        danger:  'triangle-exclamation',
                        info:    'circle-info',
                        success: 'circle-check',
                        warning: 'circle-exclamation',
                        default: null,
                    }

                    let icon = icons.hasOwnProperty(color) ? icons[color] : icons.default;

                    if (icon) {
                        for (let icon_color in icons) {
                            if (this.element.classList.contains('alert-' + icon_color)) {
                                this.element.classList.remove('alert-' + icon_color);
                                this.icon.classList.remove('fa-' + icons[icon_color]);
                            }
                        }

                        this.element.classList.add('alert-' + color);
                        this.icon.classList.add('fa-' + icons[color]);
                    }
                }

                remove() {
                    this.element.remove();
                }

                set_content(content, color) {
                    this.content.innerHTML = content;

                    if (color) {
                        this.set_color(color);
                    }
                }
            };
        } else {
            return null;
        }
    }
};
